import { NAV_ITEM_TYPE_ITEM } from 'constants/navigation.constant'
import { ADMIN } from 'constants/roles.constant'

const adminNavConfig = [
    {
        key: 'dashboard',
        path: '/',
        title: 'Dashboard',
        // translateKey: 'nav.titleFeed',
        icon: 'home',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    {
        key: 'users',
        path: '/users',
        title: 'Users',
        //translateKey: 'nav.titleFeed',
        icon: 'users',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    {
        key: 'packages',
        path: '/packages',
        title: 'Packages',
        //translateKey: 'nav.titleFeed',
        icon: 'packages',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    {
        key: 'memberships',
        path: '/memberships',
        title: 'Memberships',
        //translateKey: 'nav.titleFeed',
        icon: 'membership',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    {
        key: 'revBreak',
        path: '/revenue-breakdown',
        title: 'Revenue Breakdown',
        //translateKey: 'nav.titleFeed',
        icon: 'revBreak',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    {
        key: 'editTermsOfUse',
        path: '/editTermsOfUse',
        title: 'Terms Of Use',
        // translateKey: 'nav.titleFeed',
        icon: 'editTermsOfUse',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [ADMIN],
        subMenu: [],
    },
    // {
    //     key: 'billing',
    //     path: '',
    //     title: 'Collapse Menu',
    //     translateKey: 'nav.collapseMenu.collapseMenu',
    //     icon: 'collapseMenu',
    //     type: NAV_ITEM_TYPE_COLLAPSE,
    //     authority: [ADMIN],
    //     subMenu: [
    //         {
    //             key: 'collapseMenu.item1',
    //             path: '/collapse-menu-item-view-1',
    //             title: 'Collapse menu item 1',
    //             translateKey: 'nav.collapseMenu.item1',
    //             icon: '',
    //             type: NAV_ITEM_TYPE_ITEM,
    //             authority: [ADMIN],
    //             subMenu: [],
    //         },
    //         {
    //             key: 'collapseMenu.item2',
    //             path: '/collapse-menu-item-view-2',
    //             title: 'Collapse menu item 2',
    //             translateKey: 'nav.collapseMenu.item2',
    //             icon: '',
    //             type: NAV_ITEM_TYPE_ITEM,
    //             authority: [ADMIN],
    //             subMenu: [],
    //         },
    //     ],
    // },
]

export default adminNavConfig
